export default __webpack_public_path__ + "static/3-aef97327516688735301c9ed92c72ce4.jpg";